import { render } from "./AdminDashboardView.vue?vue&type=template&id=6ca1696e&scoped=true&ts=true"
import script from "./AdminDashboardView.vue?vue&type=script&lang=ts"
export * from "./AdminDashboardView.vue?vue&type=script&lang=ts"

import "./AdminDashboardView.vue?vue&type=style&index=0&id=6ca1696e&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ca1696e"]])

export default __exports__